import { showHideLoadingDiv } from 'src/loaders/StyleLoader';
import { onitServerBaseURL } from './onit-server-utils';
import StorageUtils from './storage-utils';

function getInstance() {
    const hash = window.location.hash;
    const cleanHash = hash.indexOf('?') !== -1 ? hash.substring(0, hash.indexOf('?')) : hash;
    return cleanHash.substring(1, cleanHash.indexOf('/') !== -1 ? cleanHash.indexOf('/') : cleanHash.length) || 'ONIT';
}

function apiBase() { return onitServerBaseURL(); }
function token() { return StorageUtils.getItem('token') || ''; }
function headers() { return { Authorization: `Bearer ${token()}` }; }
function params(bucket: string, key?: string) {
    return `instance=${encodeURIComponent(getInstance())}&bucket=${encodeURIComponent(bucket)}` +
        (key === undefined ? '' : `&key=${encodeURIComponent(key)}`);
}

export function setOrigion() { return getInstance(); }

export module BUCKETS {
    function getPrefix() { return getInstance().toUpperCase() === 'NGUS' ? 'ngus' : 'bimism'; }
    export function PERMANENT_BACKUPS() { return `${getPrefix()}.pbu`; }
    export function TEMP_BACKUPS() { return `${getPrefix()}.tbu`; }
    export function CHAT() { return `${getPrefix()}.chat`; }
    export function DOCUMENT() { return `${getPrefix()}-documents`; }
    export function COMMUNITYDOCS() { return `${getPrefix()}.commdocs`; }
    export function CONTRACTS() { return `${getPrefix()}.contracts`; }
    export function HELPCENTER() { return `${getPrefix()}.helpcenter`; }
    export function SECUREBUCKET() { return `${getPrefix()}.securebucket`; }
}

export const ACCESSTYPE = {
    PRIVATE: 'private', PUBLIC_READ: 'public-read', PUBLIC_READ_WRITE: 'public-read-write',
    AUTHENTICATED_READ: 'authenticated-read', AWS_EXEC_READ: 'aws-exec-read',
    BUCKET_OWNER_READ: 'bucket-owner-read', BUCKET_OWNER_FULL_CONTROL: 'bucket-owner-full-control'
};

export class S3 {
    GetSignedURL(bucket: string, key: string, expiresIn?: number) {
        if (!key) return '';
        return `${apiBase()}MinIO/Download?${params(bucket, key)}&token=${encodeURIComponent(token())}`;
    }
    GetBucketACL(bucketName: string) { return Promise.resolve({ Bucket: bucketName }); }
    GetBucketsList() { return Promise.resolve([]); }
    GetBucketCors(bucketName: string) { return Promise.resolve({ Bucket: bucketName, CORSRules: [] }); }

    async UploadFile(bucketName: string, fileName: string, body: Buffer | Array<any> | Blob | String | ReadableStream, callback?: (err, data) => void) {
        showHideLoadingDiv(true);
        try {
            const form = new FormData();
            const blob = body instanceof Blob ? body : new Blob([body as any]);
            form.append('file', blob, fileName);
            form.append('bucket', bucketName);
            form.append('key', fileName);
            form.append('instance', getInstance());
            const response = await fetch(`${apiBase()}MinIO/Upload`, { method: 'POST', headers: headers(), body: form });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || response.statusText);
            if (callback) callback(undefined, data);
            return data;
        } catch (err) {
            if (callback) callback(err, undefined);
            throw err;
        } finally {
            showHideLoadingDiv(false);
        }
    }

    async PutObject(bucketName: string, fileName: string, body: string) {
        const form = new FormData();
        form.append('file', new Blob([body], { type: 'text/plain' }), fileName);
        form.append('bucket', bucketName);
        form.append('key', fileName);
        form.append('instance', getInstance());
        const response = await fetch(`${apiBase()}MinIO/PutObject`, { method: 'POST', headers: headers(), body: form });
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
    }

    async GetObject(bucketName: string, fileName: string, callback: (err: any, data: any) => void) {
        try {
            const response = await fetch(`${apiBase()}MinIO/Object?${params(bucketName, fileName)}`, { headers: headers() });
            if (!response.ok) throw new Error(response.statusText);
            callback(undefined, { Body: new Uint8Array(await response.arrayBuffer()) });
        } catch (err) {
            callback(err, undefined);
        }
    }

    async GetFileList(bucketName: string, callback: (err: any, data: any) => void) {
        try {
            const response = await fetch(`${apiBase()}MinIO/Files?${params(bucketName)}`, { headers: headers() });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || response.statusText);
            callback(undefined, data);
        } catch (err) {
            callback(err, { Contents: [] });
        }
    }

    DeleteBucket(bucketName: string) { return Promise.reject(new Error(`Deleting bucket ${bucketName} is disabled`)); }

    async DeleteFile(bucketName: string, fileName: string) {
        const response = await fetch(`${apiBase()}MinIO/Object?${params(bucketName, fileName)}`, { method: 'DELETE', headers: headers() });
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
    }

    async DeleteFiles(bucketName: string, files: string[]) {
        const response = await fetch(`${apiBase()}MinIO/DeleteFiles`, {
            method: 'POST',
            headers: Object.assign({ 'Content-Type': 'application/json' }, headers()),
            body: JSON.stringify({ instance: getInstance(), bucket: bucketName, files })
        });
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
    }
}

export interface s3Contents {
    Key: string;
    LastModified: string;
    ETag: string;
    Size: string;
    StorageClass: string;
}



// WEBPACK FOOTER //
// ./src/server/utils/s3-utils.ts